// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title[data-v-0d8df783]{margin:20px 10px}.list--inline li[data-v-0d8df783]{display:inline-block}.list--no-style[data-v-0d8df783]{list-style:none}.table[data-v-0d8df783]{width:100%}.table th[data-v-0d8df783]{padding:8px;line-height:20px;text-align:left;vertical-align:bottom;border:0}.table--striped tr:nth-child(odd)>td[data-v-0d8df783]{background-color:#f9f9f9}", ""]);
// Exports
module.exports = exports;
